<cap-content-header>
  <cap-title>
    {{ "sucheNachGeometergeschäften" | translate }}
  </cap-title>
</cap-content-header>

<div class="pt-2">
  <cap-geometergeschaeft-suche-standard></cap-geometergeschaeft-suche-standard>
</div>
